/**
 * Deterministic RNG (mulberry32). The seed lives inside server-side state
 * and is stripped from every client view, so clients cannot predict dice.
 * The server picks the initial seed with crypto randomness.
 */
export interface RngState {
  s: number;
}

export function nextFloat(r: RngState): number {
  r.s = (r.s + 0x6d2b79f5) | 0;
  let t = r.s;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

export function nextInt(r: RngState, minInclusive: number, maxInclusive: number): number {
  return minInclusive + Math.floor(nextFloat(r) * (maxInclusive - minInclusive + 1));
}

export function shuffle<T>(r: RngState, arr: T[]): T[] {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = nextInt(r, 0, i);
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}
